import { validateEmail } from '../../services/validators';
import { InviteData, TeamMemberData } from '../../types/teamMembers';

export enum EmailErrorType {
  USER_ALREADY_CONTRIBUTOR = 'USER_ALREADY_CONTRIBUTOR',
  USER_ALREADY_INVITED = 'USER_ALREADY_INVITED',
  INVALID_EMAIL = 'INVALID_EMAIL'
}

export type ValidateNewContributorArgs = {
  newContributorEmail: string;
  existingContributorsEmails: Map<string, TeamMemberData>;
};

export type ValidationResult = {
  isContributorValid: boolean;
  emailErrorType: EmailErrorType
};

export const validateContributorMail = (args: ValidateNewContributorArgs): ValidationResult => {
  const { newContributorEmail, existingContributorsEmails } = args;

  const trimmedEmail = newContributorEmail.trim();

  if (existingContributorsEmails.has(trimmedEmail)) {
    const errorType = (<InviteData>existingContributorsEmails.get(trimmedEmail)).status ? EmailErrorType.USER_ALREADY_INVITED : EmailErrorType.USER_ALREADY_CONTRIBUTOR;
    return {
      isContributorValid: false,
      emailErrorType: errorType
    };
  }

  if (!validateEmail(trimmedEmail)) {
    return {
      isContributorValid: false,
      emailErrorType: EmailErrorType.INVALID_EMAIL
    };
  }

  return {
    isContributorValid: true,
    emailErrorType: null
  };
};
